import * as React from 'react';
import { Spinner } from '@spinnaker/core';
import { AsyncRequestState } from 'kayenta/reducers/asyncRequest';
export default class LoadStatesBuilder {
    onRequesting(requesting) {
        this.requesting = requesting;
        return this;
    }
    onFulfilled(fulfilled) {
        this.fulfilled = fulfilled;
        return this;
    }
    onFailed(failed) {
        this.failed = failed;
        return this;
    }
    build() {
        return ({ state }) => {
            switch (state) {
                case AsyncRequestState.Requesting:
                    return (this.requesting || (React.createElement("div", { className: "horizontal center middle spinner-container" },
                        React.createElement(Spinner, null))));
                case AsyncRequestState.Fulfilled:
                    return this.fulfilled;
                case AsyncRequestState.Failed:
                    return this.failed;
            }
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZFN0YXRlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9rYXllbnRhL2NvbXBvbmVudHMvbG9hZFN0YXRlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFFL0IsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRTFDLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBVWxFLE1BQU0sQ0FBQyxPQUFPLE9BQU8saUJBQWlCO0lBSzdCLFlBQVksQ0FBQyxVQUF1QjtRQUN6QyxJQUFJLENBQUMsVUFBVSxHQUFHLFVBQVUsQ0FBQztRQUM3QixPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7SUFFTSxXQUFXLENBQUMsU0FBc0I7UUFDdkMsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7UUFDM0IsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRU0sUUFBUSxDQUFDLE1BQW1CO1FBQ2pDLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3JCLE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVNLEtBQUs7UUFDVixPQUFPLENBQUMsRUFBRSxLQUFLLEVBQW9CLEVBQUUsRUFBRTtZQUNyQyxRQUFRLEtBQUssRUFBRTtnQkFDYixLQUFLLGlCQUFpQixDQUFDLFVBQVU7b0JBQy9CLE9BQU8sQ0FDTCxJQUFJLENBQUMsVUFBVSxJQUFJLENBQ2pCLDZCQUFLLFNBQVMsRUFBQyw0Q0FBNEM7d0JBQ3pELG9CQUFDLE9BQU8sT0FBRyxDQUNQLENBQ1AsQ0FDRixDQUFDO2dCQUNKLEtBQUssaUJBQWlCLENBQUMsU0FBUztvQkFDOUIsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDO2dCQUN4QixLQUFLLGlCQUFpQixDQUFDLE1BQU07b0JBQzNCLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQzthQUN0QjtRQUNILENBQUMsQ0FBQztJQUNKLENBQUM7Q0FDRiJ9